export default function closest(el, selector) {
    const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    while (el) {
        if (matchesSelector.call(el, selector)) {
            return el;
        }
        else {
            el = el.parentElement;
        }
    }
    return null;
}



// WEBPACK FOOTER //
// ./components/_util/closest.tsx